export enum moreLikeMeBehavior {
  REFINE,
  RESTYLE,
  LEGACY,
}
